<!-- 推广统计页面 -->
<template>
  <div class="recommendationStats">
    <div class="head-area clr">
      <div class="fl clr left-search">
        <div class="fl search-item">
          <div class="fl head-label-area">推荐类型</div>
          <Select v-model="recommendationType" style="width:200px" clearable>
            <Option :value="0" key="0">用户推荐</Option>
            <Option :value="1" key="1">商家推荐</Option>
          </Select>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">id</div>
          <Input class="fl" v-model="userId" placeholder="请输入id" clearable style="width:200px"></Input>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">用户姓名</div>
          <Input class="fl" v-model="userName" placeholder="请输入用户姓名" clearable style="width:200px"></Input>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">时间范围</div>
          <DatePicker
            class="fl"
            type="datetimerange"
            v-model="dateRange"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择时间范围"
            style="width:200px"
            :options="dateOptions"
            clearable
          ></DatePicker>
        </div>
        <!-- <div class="fl search-item" style="margin-left:20px;">
          <Button type="primary" @click="exportData">导出</Button>
          <Button type="primary" @click="showExportList" style="margin-left:10px;">查看导出列表</Button>
        </div> -->
      </div>
      <div class="fr right-search-btn">
        <Button type="primary" style="margin:0 0 10px;" icon="ios-search" @click="search">查询</Button>
        <Button @click="reset" icon="ios-refresh">重置</Button>
      </div>
    </div>
    <div class="table-area" style="margin-top:10px;">
      <Table 
        :columns="columns" 
        :data="dataList" 
        size="small" 
        :height="tableHeight"
        @on-sort-change="handleSortChange">
        <template slot-scope="{ row }" slot="recommendationType">
          <span v-if="row.recommendationType === 0">用户推荐</span>
          <span v-else-if="row.recommendationType === 1">商家推荐</span>
          <span v-else>未知类型</span>
        </template>
      </Table>
    </div>
    <div class="page-area" v-if="dataList.length">
      <Page
        :total="total"
        :current="current"
        :page-size="size"
        :page-size-opts="[20, 50, 100, 500, 1000]"
        show-total
        show-sizer
        @on-change="pageChage"
        @on-page-size-change="pageSizeChage"
      ></Page>
    </div>
    <Modal v-model="exportListModal" title="导出列表" width="600">
      <Table :columns="exportListColumns" :data="exportListData" :height="400">
        <template slot-scope="{ row }" slot="status">
            <div v-if="row.status == 'EXPORTING'">导出中</div> 
            <div v-if="row.status == 'SUCCESS'">成功</div> 
            <div v-if="row.status == 'FAILED'">失败</div> 
        </template>
        <template slot-scope="{ row }" slot="exportAction">
          <a v-if="row.status == 'SUCCESS'" @click="downloadExport(row)">下载</a>
        </template>
      </Table>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import { getRecommendationStatsList, exportRecommendationStats, getExportRecordList, downloadExportFile } from '@/api/recommendationStats.js'

export default {
  data() {
    const now = new Date();
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay() + 1); // 本周一

    const endOfWeek = new Date(now);
    endOfWeek.setDate(now.getDate() + (7 - now.getDay())); // 本周日

    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1); // 本月第一天

    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 本月最后一天

    const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1); // 上个月第一天

    const endOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 0); // 上个月最后一天

    return {
      recommendationType: null,
      userId: "",
      userName: "",
      dateRange: [],
      sortBy: null,  // 添加排序字段
      sortOrder: null,  // 添加排序方向
      tableHeight: window.innerHeight - 290,
      total: 0,
      current: 1,
      size: 20,
      dateOptions: {
        shortcuts: [
          {
            text: '本周',
            value() {
              return [startOfWeek, endOfWeek];
            }
          },
          {
            text: '本月',
            value() {
              return [startOfMonth, endOfMonth];
            }
          },
          {
            text: '上个月',
            value() {
              return [startOfLastMonth, endOfLastMonth];
            }
          }
        ]
      },
      columns: [
        {
          title: 'id',
          key: 'userId'
        },
        {
          title: '用户姓名 / 商家名称',
          key: 'userName'
        },
        {
          title: '推荐类型',
          key: 'recommendationType',
          slot: 'recommendationType'
        },
        {
          title: '上月注册数',
          key: 'lastMonthCount',
          sortable: true
        },
        {
          title: '当月注册数',
          key: 'currentMonthCount',
          sortable: true
        },
        {
          title: '累计注册数',
          key: 'totalCount',
          sortable: true
        }
      ],
      dataList: [],
      // 导出列表相关数据
      exportListModal: false,
      exportListColumns: [
        {
          title: '时间',
          key: 'createTime'
        },
        {
          title: '导出状态',
          slot: 'status',
        },
        {
          title: '操作',
          slot: 'exportAction',
          width: 100
        }
      ],
      exportListData: [],
      exportListTotal: 0,
      exportListCurrent: 1,
      exportListSize: 20
    };
  },
  created() {
    this.findPageDataList()
  },
  methods: {
    search() {
      this.current = 1
      this.findPageDataList()
    },
    reset() {
      this.recommendationType = null
      this.userId = ""
      this.userName = ""
      this.dateRange = []
      this.sortBy = null  // 重置排序字段
      this.sortOrder = null  // 重置排序方向
      this.current = 1
      this.findPageDataList()
    },
    handleSortChange({ key, order }) {
      // 将排序信息转换为后端需要的格式
      this.sortBy = key
      this.sortOrder = order === 'asc' ? 'asc' : 'desc'
      this.current = 1  // 排序时回到第一页
      this.findPageDataList()
    },
    findPageDataList() {
      let params = {
        size: this.size,
        pageIndex: this.current
      }

      if (this.recommendationType !== null && this.recommendationType !== undefined) {
        params.recommendationType = this.recommendationType
      }

      if (this.userId) {
        params.userId = this.userId
      }

      if (this.userName) {
        params.userName = this.userName
      }

      if (this.sortBy) {
        params.sortBy = this.sortBy
      }

      if (this.sortOrder) {
        params.sortOrder = this.sortOrder
      }

      if (this.dateRange && this.dateRange.length === 2) {
        // 将日期对象格式化为 yyyy-MM-dd HH:mm:ss 格式
        const formatDateTime = (date) => {
          if (!date) return '';
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        params.startDate = formatDateTime(this.dateRange[0]);
        params.endDate = formatDateTime(this.dateRange[1]);
      }

      getRecommendationStatsList(params).then(res => {
        if (res.success) {
          this.dataList = res.result.list
          this.total = res.result.total
        }
      })
    },
    exportData() {
      let params = {}

      if (this.recommendationType !== null && this.recommendationType !== undefined) {
        params.recommendationType = this.recommendationType
      }

      if (this.userId) {
        params.userId = this.userId
      }

      if (this.userName) {
        params.userName = this.userName
      }

      if (this.sortBy) {
        params.sortBy = this.sortBy
      }

      if (this.sortOrder) {
        params.sortOrder = this.sortOrder
      }

      if (this.dateRange && this.dateRange.length === 2) {
        // 将日期对象格式化为 yyyy-MM-dd HH:mm:ss 格式
        const formatDateTime = (date) => {
          if (!date) return '';
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        params.startDate = formatDateTime(this.dateRange[0]);
        params.endDate = formatDateTime(this.dateRange[1]);
      }

      exportRecommendationStats(params).then(res => {
        if (res.success) {
          this.$Message.info('正在执行导出操作，请稍后查看导出列表');
        }
      })
    },
    showExportList() {
      // 获取导出记录列表
      getExportRecordList().then(res => {
        if (res.success) {
          this.exportListData = res.result
          this.exportListModal = true;
        } 
      })
    },
    downloadExport(row) {
      // 使用API接口方式下载文件
      downloadExportFile({id: row.id}).then(res => {
        // 直接处理返回的blob数据
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = '推广统计导出_' + row.createTime + '.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);
        this.$Message.success('下载成功');
      }).catch(error => {
        this.$Message.error('下载失败：' + (error.message || '未知错误'));
      });
    },
    pageChage(page) {
      this.current = page
      this.findPageDataList()
    },
    pageSizeChage(size) {
      this.size = size
      this.findPageDataList()
    },
  }
}
</script>

<style lang='scss' scoped>
.recommendationStats {
  .left-search {
    width: calc(100% - 100px);
    .search-item {
      margin-bottom: 10px;
    }
  }
  .right-search-btn {
    width: 100px;
    border-left: 1px solid #e5e6eb;
    padding-left: 20px;
  }
  .head-label-area {
    line-height: 36px;
    margin-left: 10px;
    padding-right: 15px;
    text-align: right;
    min-width: 80px;
  }
}
</style>